(() => {
  function initViewer(dialog) {
    if (dialog.dataset.projectPhotoReady === 'true') return;
    const section = dialog.closest('.shopify-section');
    if (!section || typeof dialog.showModal !== 'function') return;

    const photos = Array.from(section.querySelectorAll('a[data-project-photo]'));
    if (!photos.length) return;
    dialog.dataset.projectPhotoReady = 'true';

    const stage = dialog.querySelector('[data-project-photo-stage]');
    const status = dialog.querySelector('[data-project-photo-status]');
    const position = dialog.querySelector('[data-project-photo-position]');
    const previous = dialog.querySelector('[data-project-photo-previous]');
    const next = dialog.querySelector('[data-project-photo-next]');
    const close = dialog.querySelector('[data-project-photo-close]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let activeIndex = 0;
    let requestId = 0;
    let trigger = null;
    let previewImage = null;
    let fullImage = null;
    let opening = false;
    let openingAnimation = null;

    function clearImages() {
      if (fullImage) {
        fullImage.onload = null;
        fullImage.onerror = null;
        fullImage.removeAttribute('src');
      }
      stage.querySelectorAll('.project-photo-viewer__image').forEach((image) => image.remove());
      previewImage = null;
      fullImage = null;
    }

    function revealFull(preview, full, alt, currentRequest) {
      if (currentRequest !== requestId || opening) return;
      status.textContent = '';
      full.alt = alt;
      preview.alt = '';
      full.classList.add('is-ready');
      if (reduceMotion.matches) {
        preview.remove();
      } else {
        window.setTimeout(() => {
          if (currentRequest === requestId) preview.remove();
        }, 180);
      }
    }

    function showPhoto(index, initial = false) {
      activeIndex = (index + photos.length) % photos.length;
      const photo = photos[activeIndex];
      const thumbnail = photo.querySelector('img');
      const alt = photo.dataset.projectPhotoAlt || 'Finished Print-MO project photo';
      const currentRequest = ++requestId;
      sizeStage(photo);
      clearImages();
      status.textContent = '';

      const preview = document.createElement('img');
      preview.className = 'project-photo-viewer__image project-photo-viewer__image--preview';
      preview.decoding = 'async';
      preview.alt = alt;
      preview.src = thumbnail?.currentSrc || thumbnail?.src || photo.dataset.projectPhotoSmall;
      preview.onerror = () => {
        if (currentRequest === requestId) status.textContent = 'Loading photo…';
      };
      stage.appendChild(preview);
      previewImage = preview;

      const full = document.createElement('img');
      full.className = 'project-photo-viewer__image project-photo-viewer__image--full';
      full.decoding = 'async';
      full.alt = '';
      full.onload = () => revealFull(preview, full, alt, currentRequest);
      full.onerror = () => {
        if (currentRequest === requestId) status.textContent = 'Larger photo unavailable; showing preview.';
      };
      stage.appendChild(full);
      fullImage = full;
      full.src = window.innerWidth < 750 ? photo.dataset.projectPhotoSmall : photo.dataset.projectPhoto;

      position.textContent = `${activeIndex + 1} of ${photos.length}`;
      previous.hidden = photos.length < 2;
      next.hidden = photos.length < 2;
      if (!initial && !reduceMotion.matches && typeof preview.animate === 'function') {
        preview.animate([{ opacity: .55 }, { opacity: 1 }], { duration: 140, easing: 'ease-out' });
      }
    }

    function stopOpening() {
      if (openingAnimation) {
        openingAnimation.onfinish = null;
        openingAnimation.cancel();
        openingAnimation = null;
      }
      opening = false;
    }

    function navigate(delta) {
      stopOpening();
      showPhoto(activeIndex + delta);
    }

    function sizeStage(photo) {
      const thumbnail = photo.querySelector('img');
      const imageWidth = Number(photo.dataset.projectPhotoWidth) || thumbnail?.naturalWidth || Number(thumbnail?.getAttribute('width')) || 4;
      const imageHeight = Number(photo.dataset.projectPhotoHeight) || thumbnail?.naturalHeight || Number(thumbnail?.getAttribute('height')) || 3;
      const ratio = imageWidth / imageHeight;
      const mobile = window.innerWidth < 750;
      const maxWidth = Math.max(120, Math.min(window.innerWidth - (mobile ? 40 : 120), mobile ? 680 : 1200));
      const maxHeight = Math.max(120, window.innerHeight - (mobile ? 150 : 180));
      const width = Math.min(maxWidth, maxHeight * ratio);
      stage.style.width = `${Math.floor(width)}px`;
      stage.style.height = `${Math.floor(width / ratio)}px`;
    }

    section.addEventListener('click', (event) => {
      const photo = event.target.closest('a[data-project-photo]');
      if (!photo || !section.contains(photo) || dialog.contains(photo)) return;
      event.preventDefault();
      trigger = photo;
      const source = photo.querySelector('img')?.getBoundingClientRect() || photo.getBoundingClientRect();
      opening = !reduceMotion.matches;
      showPhoto(photos.indexOf(photo), true);
      dialog.showModal();
      close.focus();

      if (!opening || !source.width || !source.height || typeof previewImage.animate !== 'function') {
        opening = false;
        if (fullImage?.complete && fullImage.naturalWidth) fullImage.onload();
        return;
      }

      const target = stage.getBoundingClientRect();
      const scale = Math.min(source.width / target.width, source.height / target.height);
      const x = source.left + source.width / 2 - target.left - target.width / 2;
      const y = source.top + source.height / 2 - target.top - target.height / 2;
      openingAnimation = previewImage.animate(
        [
          { transform: `translate(${x}px, ${y}px) scale(${scale})`, opacity: .7 },
          { transform: 'translate(0, 0) scale(1)', opacity: 1 }
        ],
        { duration: 280, easing: 'cubic-bezier(.16, 1, .3, 1)' }
      );
      openingAnimation.onfinish = () => {
        opening = false;
        openingAnimation = null;
        if (fullImage?.complete && fullImage.naturalWidth) fullImage.onload();
      };
    });

    previous.addEventListener('click', () => navigate(-1));
    next.addEventListener('click', () => navigate(1));
    window.addEventListener('resize', () => {
      if (dialog.open) sizeStage(photos[activeIndex]);
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); navigate(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); navigate(1); }
    });
    dialog.addEventListener('close', () => {
      stopOpening();
      requestId += 1;
      clearImages();
      status.textContent = '';
      if (trigger && trigger.isConnected) trigger.focus();
    });
  }

  function initAll(root) {
    root.querySelectorAll('[data-project-photo-viewer]').forEach(initViewer);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
